import { useController } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ErrorLabel from "./ErrorLabel";
import FloatLabel from "./FloatLabel";
import ReactSelect from "./ReactSelect";

export default function SelectControl({ control, name, label, isRequired = false, rules, isMulti = false, options, onChange, ...rest }) {
  const { t } = useTranslation();
  const {
    field: { value = "", onChange: onChangeControl, ...field },
    fieldState: { error },
  } = useController({
    name,
    control,
    rules: { required: isRequired && `${label}${t("label.is_required")}`, ...rules },
  });

  const handleOnChange = (e) => {
    onChangeControl(e);
    if (onChange) onChange(value);
  };

  return (
    <>
      <FloatLabel label={label} isRequired={isRequired}>
        <ReactSelect colorScheme="brand" value={isMulti ? value : options?.filter((option) => option?.value === value?.value)} onChange={handleOnChange} isMulti={isMulti} options={options} {...field} {...rest} />
        <ErrorLabel>{error?.message}</ErrorLabel>
      </FloatLabel>
    </>
  );
}
